@import "/src/styles/mixins.sass"

.container
    display: inline-flex
    flex-direction: column
    gap: 0.2rem

    &.disabled
        .label, .helperText
            color: var(--color-black-primary-disabled)

            input
                background-color: var(--color-primary-white)
                color: var(--color-black-primary-disabled)

    &.invalid
        .label, .helperText
            color: var(--color-red-dangerous)

        &.disabled
            .label, .helperText, .label input
                color: var(--color-red-dangerous-disabled)

.label, .helperText
    margin: 0 0.75rem
    text-transform: capitalize

.label
    @include label
    display: flex
    align-items: center

    span
        flex-grow: 1
        display: flex
        justify-content: flex-end

    input
        @include reset
        @include input
        background-color: var(--color-grey-primary)
        padding: 0.375rem
        border-radius: 0.75rem
        max-width: 12.2ch
        text-align: center

        &:focus-visible
            outline: none

        &[disabled]
            background-color: var(--color-primary-white)
            color: var(--color-black-primary-disabled)

.helperText
    @include label($disabled: true)
